import React from "react";
import { Flex, Text } from "../../../assets/ui";

import { StyledCard, Block, StyleSectionWrapper } from "./ui";

const JobInfoSection = ({ job }) => {
  return (
    <StyleSectionWrapper>
      <Flex justifyContent={"space-between"}>
        <Flex flexDirection={["column"]} width={["100%", null, "50%"]}>
          <Block>
            <h3>Role</h3>
            <p>{job.role}</p>
          </Block>

          <StyledCard display={["block", null, "none"]}>
            <h3>Salary</h3>
            <p>
              Base salary <Text fontWeight="bold">£21600 year</Text> <br />1
              commission <Text fontWeight="bold">£50,000 year 1</Text>,<br />
              <Text fontWeight="bold">£38000 year2</Text> commission £100,000
            </p>
            <h3>Location</h3>
            <p>
              Location – you will choose the city that you want and that will be
              your territory{" "}
            </p>
          </StyledCard>

          <Block>
            <h3>Additional info</h3>
            <p>{job.additionalInfo}</p>
          </Block>
        </Flex>
        <StyledCard display={["none", null, "block"]}>
          <h3>Salary</h3>
          <p>
            Base salary <Text fontWeight="bold">£21600 year</Text> <br />1
            commission <Text fontWeight="bold">£50,000 year 1</Text>,<br />
            <Text fontWeight="bold">£38000 year2</Text> commission £100,000
          </p>
          <h3>Location</h3>
          <p>
            Location – you will choose the city that you want and that will be
            your territory{" "}
          </p>
        </StyledCard>
      </Flex>
    </StyleSectionWrapper>
  );
};

export default JobInfoSection;
